// =====================================================
// Options du select « Statut » de la fiche équipage (CrewInfoForm)
// =====================================================
import { CREW_STATUS, CREW_STATUS_LABELS, type CrewStatus } from '../types/crew';

export interface CrewStatusOption {
  value: CrewStatus;
  label: string;
}

// Statuts proposés À LA MAIN. Les statuts posés par les automatismes (BPI en
// attente, cf. 00127/00133/00206 ; BED téléchargé, BED incomplet — paiement,
// Inscrit, cf. 00232) et les valeurs de l'enum base inconnues du front
// (cf. #239) n'y sont pas : on ne les choisit pas, on les constate.
// Voir buildStatusSelectOptions.
const STATUS_SELECT_OPTIONS: CrewStatusOption[] = [
  { value: CREW_STATUS.PRE_REGISTERED, label: CREW_STATUS_LABELS[CREW_STATUS.PRE_REGISTERED] },
  { value: CREW_STATUS.BED_INCOMPLETE, label: CREW_STATUS_LABELS[CREW_STATUS.BED_INCOMPLETE] },
  { value: CREW_STATUS.BED_COMPLETE, label: CREW_STATUS_LABELS[CREW_STATUS.BED_COMPLETE] },
  {
    value: CREW_STATUS.CANCELLATION_COMPLIANT,
    label: CREW_STATUS_LABELS[CREW_STATUS.CANCELLATION_COMPLIANT],
  },
  {
    value: CREW_STATUS.CANCELLATION_NON_COMPLIANT,
    label: CREW_STATUS_LABELS[CREW_STATUS.CANCELLATION_NON_COMPLIANT],
  },
  {
    value: CREW_STATUS.POSTPONEMENT_COMPLIANT,
    label: CREW_STATUS_LABELS[CREW_STATUS.POSTPONEMENT_COMPLIANT],
  },
  {
    value: CREW_STATUS.POSTPONEMENT_NON_COMPLIANT,
    label: CREW_STATUS_LABELS[CREW_STATUS.POSTPONEMENT_NON_COMPLIANT],
  },
  { value: CREW_STATUS.COMPLETED, label: CREW_STATUS_LABELS[CREW_STATUS.COMPLETED] },
  { value: CREW_STATUS.ARCHIVED, label: CREW_STATUS_LABELS[CREW_STATUS.ARCHIVED] },
];

/**
 * Options du select de statut pour un équipage donné : la liste manuelle, plus
 * le statut COURANT s'il n'en fait pas partie. Sans cela, un équipage en statut
 * automatique (ex. « BED téléchargé », « BPI en attente ») affiche un select
 * vide — `<select>` natif, valeur hors options — et l'utilisateur ne peut que
 * choisir un autre statut : c'est la rétrogradation manuelle que 00206 décrit
 * et que le BED rend courante. Le statut courant est mis en tête pour rester
 * lisible.
 *
 * `CREW_STATUS_LABELS[current] ?? current` : selon les types la branche `??`
 * est inatteignable, mais la base peut porter une valeur absente de
 * `CrewStatus` ; on affiche alors la valeur brute.
 */
export function buildStatusSelectOptions(
  current: CrewStatus
): { value: CrewStatus; label: string }[] {
  if (STATUS_SELECT_OPTIONS.some((o) => o.value === current)) return STATUS_SELECT_OPTIONS;
  return [
    { value: current, label: CREW_STATUS_LABELS[current] ?? current },
    ...STATUS_SELECT_OPTIONS,
  ];
}
